<template>
<v-container>
  <v-btn class="ma-2" :color="color">{{ missing }}</v-btn>
</v-container>
</template>

<script>
export default {
    props: {
	expected: Number,
	available: Number,
    },

    data: () => ({

    }),
    
    computed: {

	missing: function() {
	    return this.expected - this.available;
	},

	color() {
	    if (this.missing === 0) {
		return 'success';
	    } else if (this.missing === this.expected) {
		return 'error';
	    } else {
		return 'warning';
	    }
	},
    },
};
</script>

<style lang="scss" scoped>

</style>
